const state = {
    snack: false,
    snackText: "",
    snackColor: "warning",
    useDevDatabase: false,

}

const mutations = {
    setSnackText(state, payload) {
        state.snackText = payload
        state.snack = true
    },

    setSnack(state, payload) {
        state.snack = payload
    },

    setSnackColor(state, payload) {
        state.snackColor = payload
    },
    

    setUseDevDatabase(state, payload) {
		state.useDevDatabase = payload
	},
}

const getters = {
	getDatabase : state => {
		return state.useDevDatabase ? 'cms_b' : 'cms_a'
	},
}

const actions = {
   
}

export default {
    state,
    mutations,
    getters,
    actions
}
